import { jsx as _jsx } from "react/jsx-runtime";
import ExpanderList from '@helsenorge/designsystem-react/components/ExpanderList';
import { Tool } from './Tool';
export const ToolList = ({ tools, color = 'neutral', toolTitleHtmlMarkup, ...rest }) => (_jsx(ExpanderList, { color: color, children: tools.map(tool => (_jsx(ExpanderList.Expander, { title: tool.Navn, titleHtmlMarkup: toolTitleHtmlMarkup, children: _jsx(Tool, { tool: tool, ...rest }) }, tool.VerktoyId))) }));
